import React from 'react'

export default function SqaureLoader() {
    return (
        <div className="card-body text-center">
            <div className="lds-facebook"><div /><div /><div /></div>
        </div>

    )
}
